<script setup lang="ts">
  import { useForwardProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{ class?: HTMLAttributes['class'] }>();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div
    v-bind="forwardedProps"
    :class="
      cn(
        'property-list-item grid min-w-fit h-fit font-normal group-[.item-horizontal]:leading-5 group-[.item-horizontal]:grid-cols-[105px_1fr] group-[.item-horizontal]:gap-6 group-[.item-vertical]:flex group-[.item-vertical]:flex-col group-[.item-vertical]:gap-2 group-[.item-vertical]:w-fit group-[.item-horizontal.full]:flex group-[.item-horizontal.full]:justify-between group-[.item-horizontal.full]:w-full group-[.item-horizontal.full]:grid-cols-[auto_1fr]',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<style lang="postcss" scoped></style>
